import { Pipe, PipeTransform } from '@angular/core';
import { FloorClass } from '../../../models/floor.class';

@Pipe({
  name: 'resultList',
  standalone: false,
})
export class ResultList implements PipeTransform {
  transform(val: any, keyValue: any) {
    if (keyValue && Array.isArray(keyValue) && keyValue.length > 1) {
      const key = keyValue
        .sort((a, b) => String(a).localeCompare(String(b)))
        .find(element => val[element] && val[element] !== null);
      return val[key];
    } else {
      return keyValue ? val[keyValue] : val;
    }
  }
}

@Pipe({
  name: 'disableInput',
  standalone: false,
})
export class DisableInput implements PipeTransform {
  transform(floor: FloorClass) {
    return floor.containsInactiveSpaces || (!!floor.spaces && floor.spaces.length > 0);
  }
}
